module.exports = __webpack_public_path__ + "static/img/tx4-b.292b86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/tx4-b.png
// module id = TNr/
// module chunks = 1